/**
 * Bundle Addon Card Component
 * Handles rendering of different addon card types (regular, santa video, number plate, etc.)
 */

window.BundleAddonCard = (function() {
  'use strict';

  /**
   * Get icon SVG based on icon type (despite the function name, returns SVG not emoji)
   * @param {string} icon - Icon identifier
   * @returns {string} SVG icon HTML
   */
  function getIconEmoji(icon) {
    const icons = {
      battery: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M6.5 6H17.5M6.5 6C4.01472 6 2 8.01472 2 10.5V13.5C2 15.9853 4.01472 18 6.5 18H17.5C19.9853 18 22 15.9853 22 13.5V10.5C22 8.01472 19.9853 6 17.5 6M6.5 6V4M17.5 6V4M6 10.5H10M6 13.5H14"></path></svg>',
      wheel: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><circle stroke-linecap="round" stroke-linejoin="round" cx="12" cy="12" r="9"></circle><circle stroke-linecap="round" stroke-linejoin="round" cx="12" cy="12" r="3"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M12 3V9M12 15V21M3 12H9M15 12H21M5.636 5.636L9.879 9.879M14.121 14.121L18.364 18.364M18.364 5.636L14.121 9.879M9.879 14.121L5.636 18.364"></path></svg>',
      motor: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M13 2L3 14H12L11 22L21 10H12L13 2Z"></path></svg>',
      speed: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M13 2L3 14H12L11 22L21 10H12L13 2Z"></path></svg>',
      seat: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M5 14H19C19.5304 14 20.0391 14.2107 20.4142 14.5858C20.7893 14.9609 21 15.4696 21 16V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V16C3 15.4696 3.21071 14.9609 3.58579 14.5858C3.96086 14.2107 4.46957 14 5 14ZM7 14V7C7 6.46957 7.21071 5.96086 7.58579 5.58579C7.96086 5.21071 8.46957 5 9 5H15C15.5304 5 16.0391 5.21071 16.4142 5.58579C16.7893 5.96086 17 6.46957 17 7V14M6 3H18"></path></svg>',
      remote: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><rect stroke-linecap="round" stroke-linejoin="round" x="5" y="2" width="14" height="20" rx="2"></rect><path stroke-linecap="round" stroke-linejoin="round" d="M12 6V8M12 10V12M9 15H11M13 15H15M9 18H11M13 18H15"></path></svg>',
      plate: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><rect stroke-linecap="round" stroke-linejoin="round" x="2" y="6" width="20" height="12" rx="2"></rect><path stroke-linecap="round" stroke-linejoin="round" d="M7 10V14M10 10V14M13 10V14M16 10V14"></path></svg>',
      letter: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z"></path></svg>',
      letters: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z"></path></svg>',
      video: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10L19.5528 7.72361C20.2177 7.39116 21 7.87465 21 8.61803V15.382C21 16.1253 20.2177 16.6088 19.5528 16.2764L15 14M5 18H13C14.1046 18 15 17.1046 15 16V8C15 6.89543 14.1046 6 13 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18Z"></path></svg>',
      palette: '<svg width="28" height="28" viewBox="0 0 14 14" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M8.99984 2.33337C8.99984 3.80613 10.1937 5.00004 11.6665 5.00004M1.6665 12.3334L1.95314 10.9002C2.09439 10.1939 2.16502 9.84078 2.29419 9.51149C2.40883 9.2192 2.55749 8.94143 2.73709 8.68391C2.93944 8.39378 3.19409 8.13913 3.7034 7.62983L9.66659 1.6667C10.403 0.930324 11.5969 0.930339 12.3332 1.66673V1.66673C13.0696 2.4031 13.0696 3.59697 12.3332 4.33333L6.37004 10.2965C5.86075 10.8058 5.6061 11.0604 5.31597 11.2628C5.05845 11.4424 4.78068 11.591 4.4884 11.7057C4.1591 11.8349 3.80597 11.9055 3.0997 12.0467L1.6665 12.3334Z"></path></svg>',
      shield: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2L4 6V12C4 17.55 7.84 22.54 12 23C16.16 22.54 20 17.55 20 12V6L12 2ZM12 12.5L8 10L9.5 14L7 17H12V12.5Z"></path></svg>',
      warranty: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2L4 6V12C4 17.55 7.84 22.54 12 23C16.16 22.54 20 17.55 20 12V6L12 2ZM12 12.5L8 10L9.5 14L7 17H12V12.5Z"></path></svg>',
      cover: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2V22M12 2C6.47715 2 2 6.47715 2 12H22C22 6.47715 17.5228 2 12 2ZM12 18C12 19.1046 12.8954 20 14 20C15.1046 20 16 19.1046 16 18"></path></svg>',
      tools: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M21.5355 3.46447C20.5762 2.50517 19.1008 2.12619 17.7313 2.49993L15.5 4.73124L19.2687 8.49993L21.5 6.26862C21.8737 4.89914 21.4948 3.42378 20.5355 2.46447ZM20.5355 3.46447C21.4948 4.42378 21.8737 5.89914 21.5 7.26862M3.53553 15.4645C2.57622 16.4238 2.19724 17.8992 2.57098 19.2687L4.80229 21.5M4.80229 21.5L7.03359 19.2687M4.80229 21.5L2.57098 19.2687M4.80229 21.5C6.17178 21.8737 7.64713 21.4948 8.60644 20.5355M19.0606 8.70718L14.7929 13L11 9.20718L15.2676 4.93946M9.79289 15L8.58579 16.2071C8.21071 16.5822 8.21071 17.1909 8.58579 17.5659L8.93934 17.9194C9.31441 18.2945 9.92289 18.2945 10.298 17.9194L11.5 16.7071"></path></svg>',
      gift: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8V21M3 10H21M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10M3 10V8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8V10M9 6C9 4.89543 9.89543 4 11 4C12.1046 4 13 4.89543 13 6M9 6C9 7.10457 9.89543 8 11 8H13C14.1046 8 15 7.10457 15 6M15 6C15 4.89543 14.1046 4 13 4C11.8954 4 11 4.89543 11 6"></path></svg>',
      gifts: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8V21M3 10H21M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10M3 10V8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8V10M9 6C9 4.89543 9.89543 4 11 4C12.1046 4 13 4.89543 13 6M9 6C9 7.10457 9.89543 8 11 8H13C14.1046 8 15 7.10457 15 6M15 6C15 4.89543 14.1046 4 13 4C11.8954 4 11 4.89543 11 6"></path></svg>',
      wrap: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8V21M3 10H21M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10M3 10V8C3 6.89543 3.89543 6 5 6H19C20.1046 6 21 6.89543 21 8V10M9 6C9 4.89543 9.89543 4 11 4C12.1046 4 13 4.89543 13 6M9 6C9 7.10457 9.89543 8 11 8H13C14.1046 8 15 7.10457 15 6M15 6C15 4.89543 14.1046 4 13 4C11.8954 4 11 4.89543 11 6"></path></svg>',
      certificate: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12L11 14L15 10M9 19L11 21L13 19M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"></path></svg>',
      traffic: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><rect stroke-linecap="round" stroke-linejoin="round" x="7" y="2" width="10" height="20" rx="2"></rect><circle cx="12" cy="6.5" r="1.5"></circle><circle cx="12" cy="12" r="1.5"></circle><circle cx="12" cy="17.5" r="1.5"></circle></svg>',
      usb: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 19V5M12 5L15 8M12 5L9 8M17 12V15C17 16.1046 16.1046 17 15 17H13M7 9V12C7 13.1046 7.89543 14 9 14H11M13 19C13 20.1046 12.1046 21 11 21C9.89543 21 9 20.1046 9 19C9 17.8954 9.89543 17 11 17C12.1046 17 13 17.8954 13 19Z"></path></svg>',
      bluetooth: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M6.5 6.5L17.5 17.5L12 23V1L17.5 6.5L6.5 17.5"></path></svg>',
      helmet: '<svg width="28" height="28" viewBox="0 0 24 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M12 3C7.58172 3 4 6.58172 4 11V15H7C7.55228 15 8 15.4477 8 16V18C8 18.5523 7.55228 19 7 19H4C3.44772 19 3 18.5523 3 18V11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11V18C21 18.5523 20.5523 19 20 19H17C16.4477 19 16 18.5523 16 18V16C16 15.4477 16.4477 15 17 15H20V11C20 6.58172 16.4183 3 12 3Z"></path></svg>'
    };
    // Default package icon
    return icons[icon] || '<svg width="28" height="28" viewBox="0 0 25 24" stroke="rgb(107, 114, 128)" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="M7.99988 9.5L17 4M12.5 12.5L21.5 7M12.5 12.5L3.5 7M12.5 12.5V22.5M2.5 9.71771V14.2823C2.5 15.2733 2.5 15.7688 2.64219 16.2141C2.76802 16.6081 2.97396 16.9718 3.24708 17.2824C3.55572 17.6334 3.98062 17.8884 4.83042 18.3983L10.0304 21.5183C10.9283 22.057 11.3773 22.3264 11.8565 22.4316C12.2805 22.5247 12.7195 22.5247 13.1435 22.4316C13.6227 22.3264 14.0717 22.057 14.9696 21.5183L20.1696 18.3983C21.0194 17.8884 21.4443 17.6334 21.7529 17.2824C22.026 16.9718 22.232 16.6081 22.3578 16.2141C22.5 15.7688 22.5 15.2733 22.5 14.2823V9.71771C22.5 8.72669 22.5 8.23117 22.3578 7.78593C22.232 7.39192 22.026 7.02818 21.7529 6.71757C21.4443 6.36657 21.0194 6.11163 20.1696 5.60175L14.9696 2.48175C14.0717 1.94301 13.6227 1.67364 13.1435 1.56839C12.7195 1.4753 12.2805 1.4753 11.8565 1.56839C11.3773 1.67364 10.9283 1.94301 10.0304 2.48175L4.83042 5.60175C3.98062 6.11163 3.55572 6.36657 3.24708 6.71757C2.97396 7.02818 2.76802 7.39192 2.64219 7.78593C2.5 8.23117 2.5 8.72669 2.5 9.71771Z"></path></svg>';
  }

  /**
   * Render Santa Video special card
   */
  function renderSantaVideoCard(addon, stepId, isSelected, requiresConfig, hasConfig) {
    return `
      <div class="bundle-option santa-video-special ${isSelected ? 'selected' : ''}"
           data-addon-handle="${addon.handle}"
           data-step="${stepId}"
           onclick="toggleAddon('${stepId}', '${addon.handle}')"
           style="padding: 0; position: relative; display: block !important; overflow: hidden;">

        ${requiresConfig && !hasConfig ? `<div class="config-badge config-badge--customize">Click to Customise</div>` : ''}
        ${hasConfig ? `<div class="config-badge config-badge--configured">✓ Click to Edit</div>` : ''}

        <div style="position: relative; margin: 0; overflow: hidden; background: #000;">

          <div class="bundle-option__checkbox" style="position: absolute; top: 12px; left: 12px; z-index: 10;">
            ${isSelected ? '<span class="bundle-option__checkbox-icon">✓</span>' : ''}
          </div>

          <button
            id="mute-btn-${addon.handle}"
            onclick="event.stopPropagation();
              const video = document.getElementById('santa-video-${addon.handle}');
              const btn = document.getElementById('mute-btn-${addon.handle}');
              video.muted = !video.muted;
              btn.innerHTML = video.muted
                ? '<svg style=\\'width: 16px; height: 16px;\\' fill=\\'none\\' stroke=\\'currentColor\\' viewBox=\\'0 0 24 24\\'><path stroke-linecap=\\'round\\' stroke-linejoin=\\'round\\' stroke-width=\\'2\\' d=\\'M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z\\' clip-rule=\\'evenodd\\'/><path stroke-linecap=\\'round\\' stroke-linejoin=\\'round\\' stroke-width=\\'2\\' d=\\'M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2\\'/></svg>'
                : '<svg style=\\'width: 16px; height: 16px;\\' fill=\\'none\\' stroke=\\'currentColor\\' viewBox=\\'0 0 24 24\\'><path stroke-linecap=\\'round\\' stroke-linejoin=\\'round\\' stroke-width=\\'2\\' d=\\'M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z\\'/></svg>';"
            style="position: absolute; top: 12px; right: 12px; z-index: 10; background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s;"
            onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
            onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
            <svg style="width: 16px; height: 16px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clip-rule="evenodd"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/>
            </svg>
          </button>

          <video
            id="santa-video-${addon.handle}"
            autoplay
            muted
            loop
            playsinline
            webkit-playsinline
            x5-playsinline
            style="width: 100%; display: block; aspect-ratio: 16/9; object-fit: cover;">
            <source src="https://cdn.shopify.com/videos/c/o/v/d150759c29aa4248aa51c7c65329ad82.mp4" type="video/mp4">
          </video>

          <div style="position: absolute; bottom: 10px; left: 10px; right: 10px; display: flex; justify-content: space-between; gap: 8px; z-index: 10;">
            <button onclick="event.stopPropagation(); handleVideoFullscreen('santa-video-${addon.handle}');"
              style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
              onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
              <svg style="width: 14px; height: 14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
              </svg>
              Full Screen
            </button>

            <button onclick="event.stopPropagation(); window.BundleHelpModals?.show('modal-santa-video-help');"
              style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
              onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
              <svg style="width: 14px; height: 14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Learn More
            </button>
          </div>
        </div>

        <div style="padding: 12px;">
          <div class="bundle-option__name" style="font-size: 1rem; font-weight: 700; margin-bottom: 6px;">
            ${addon.name}
            <span style="background: rgb(var(--color-primary)); color: white; padding: 2px 8px; border-radius: 4px; font-size: 0.7rem; margin-left: 8px;">NEW</span>
          </div>

          <div class="bundle-option__description" style="margin-bottom: 8px; color: rgb(var(--color-drawer-text) / 0.8); font-size: 0.85rem;">
            ${addon.description}
          </div>

          <div style="background: rgb(var(--color-primary) / 0.05); padding: 8px; border-radius: 8px; margin-bottom: 8px; border-left: 3px solid rgb(var(--color-primary));">
            <div style="font-size: 0.75rem; line-height: 1.5; color: rgb(var(--color-drawer-text) / 0.9);">
              <div style="display: flex; align-items: flex-start; gap: 8px; margin-bottom: 6px;">
                <svg style="width: 16px; height: 16px; margin-top: 2px; flex-shrink: 0; color: rgb(var(--color-primary));" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"/>
                </svg>
                <span>Upload a photo of your living room</span>
              </div>
              <div style="display: flex; align-items: flex-start; gap: 8px; margin-bottom: 6px;">
                <svg style="width: 16px; height: 16px; margin-top: 2px; flex-shrink: 0; color: rgb(var(--color-primary));" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 7H7v6h6V7z"/><path fill-rule="evenodd" d="M7 2a1 1 0 012 0v1h2V2a1 1 0 112 0v1h2a2 2 0 012 2v2h1a1 1 0 110 2h-1v2h1a1 1 0 110 2h-1v2a2 2 0 01-2 2h-2v1a1 1 0 11-2 0v-1H9v1a1 1 0 11-2 0v-1H5a2 2 0 01-2-2v-2H2a1 1 0 110-2h1V9H2a1 1 0 010-2h1V5a2 2 0 012-2h2V2zM5 5h10v10H5V5z" clip-rule="evenodd"/>
                </svg>
                <span>Beautiful animated video (Disney/Pixar-style)</span>
              </div>
              <div style="display: flex; align-items: flex-start; gap: 8px;">
                <svg style="width: 16px; height: 16px; margin-top: 2px; flex-shrink: 0; color: rgb(var(--color-primary));" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 6a2 2 0 012-2h6a2 2 0 012 6v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"/>
                </svg>
                <span>Santa puts a bow on the toy in YOUR home!</span>
              </div>
            </div>
          </div>

          <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: ${hasConfig ? '12px' : '0'};">
            <div class="bundle-option__price" style="font-size: 1.1rem; font-weight: 800; color: rgb(var(--color-primary)); margin: 0;">
              ${window.bundleAdapter.formatPrice(addon.price)}
              ${addon.compareAtPrice && addon.compareAtPrice > addon.price ? `<span style="text-decoration: line-through; color: rgb(var(--color-drawer-text) / 0.5); font-size: 0.9rem; margin-left: 8px;">${window.bundleAdapter.formatPrice(addon.compareAtPrice)}</span>` : ''}
            </div>
            ${!hasConfig ? `
              <button
                onclick="event.stopPropagation(); toggleAddon('${stepId}', '${addon.handle}');"
                style="background: rgb(var(--color-primary)); color: white; border: none; padding: 10px 20px; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; transition: opacity 0.2s; white-space: nowrap;"
                onmouseover="this.style.opacity='0.9'"
                onmouseout="this.style.opacity='1'">
                Customise
              </button>
            ` : ''}
          </div>

          ${hasConfig ? `
            <div class="bundle-option__config-display" style="background: rgb(var(--color-primary) / 0.1); padding: 10px 12px; border-radius: 8px; font-size: 0.85rem; display: flex; align-items: center; gap: 8px;">
              <svg style="width: 16px; height: 16px; color: rgb(var(--color-primary)); flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <span><strong>Configured:</strong> ${isSelected.configuration.childName} | ${isSelected.configuration.email}</span>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  /**
   * Render Santa Letter special card (now theme-aware for generic/christmas modes)
   */
  function renderSantaLetterCard(addon, stepId, isSelected, requiresConfig, hasConfig) {
    const hasVideo = addon.config?.videoUrl;
    const santaLetterImage = addon.featured_image;

    // Theme detection - check for generic mode
    const isChristmasTheme = window.bundleLetterPromoTheme === 'christmas';
    const showFestiveOverlay = isChristmasTheme && !hasVideo && santaLetterImage;
    const ENABLE_SNOW_ANIMATION = false; // Can be configured
    const showSnow = ENABLE_SNOW_ANIMATION && showFestiveOverlay;

    // Theme-aware text
    const cardName = isChristmasTheme
      ? (addon.name || 'Magical Letter from Santa')
      : 'FREE Personalised Letter';
    const cardDescription = isChristmasTheme
      ? (addon.description || 'Free magical letter from Santa with their name - the perfect finishing touch')
      : 'Free personalised letter with their name - the perfect finishing touch';

    // Theme-aware gradient
    const cardGradient = isChristmasTheme
      ? 'linear-gradient(135deg,#C41E3A 0%,#165B33 100%)'
      : 'linear-gradient(135deg, rgb(107 114 128 / 0.15) 0%, rgb(107 114 128 / 0.05) 100%)';

    const mediaContent = hasVideo
      ? `<video
           id="santa-letter-video-${addon.handle}"
           autoplay
           muted
           loop
           playsinline
           webkit-playsinline
           x5-playsinline
           style="width: 100%; display: block; aspect-ratio: 16/9; object-fit: cover;">
           <source src="${addon.config.videoUrl}" type="video/mp4">
         </video>`
      : (santaLetterImage
          ? `<div style="width:100%;aspect-ratio:4/1;position:relative;overflow:hidden;background:${cardGradient};"><img src="${santaLetterImage}" alt="${cardName}" style="width:100%;height:100%;object-fit:cover;opacity:0.9;${isChristmasTheme ? 'mix-blend-mode:luminosity;' : ''}">${showSnow?`<div class="pw-slp-snowflakes"><div class="pw-slp-snowflake" style="left:20%;animation-delay:0s;">❄</div><div class="pw-slp-snowflake" style="left:60%;animation-delay:1.5s;">❄</div><div class="pw-slp-snowflake" style="left:85%;animation-delay:0.7s;">❄</div></div>`:''}</div>`
          : `<div style="width:100%;aspect-ratio:5/1;display:flex;align-items:center;justify-content:center;background:rgb(var(--color-primary)/0.1);font-size:2rem;">${getIconEmoji(addon.icon)}</div>`
        );

    return `
      <div class="bundle-option santa-letter-special ${isSelected ? 'selected' : ''}"
           data-addon-handle="${addon.handle}"
           data-step="${stepId}"
           onclick="toggleAddon('${stepId}', '${addon.handle}')"
           style="padding: 0; position: relative; display: block !important; overflow: hidden;">

        ${requiresConfig && !hasConfig ? `<div class="config-badge config-badge--customize">Click to Customise</div>` : ''}
        ${hasConfig ? `<div class="config-badge config-badge--configured">✓ Click to Edit</div>` : ''}

        <div style="position: relative; margin: 0; overflow: hidden; background: ${hasVideo ? '#000' : 'rgb(var(--color-primary) / 0.05)'};">

          <div class="bundle-option__checkbox" style="position: absolute; top: 12px; left: 12px; z-index: 10;">
            ${isSelected ? '<span class="bundle-option__checkbox-icon">✓</span>' : ''}
          </div>

          ${hasVideo ? `
          <button
            id="mute-btn-${addon.handle}"
            onclick="event.stopPropagation(); handleMuteToggle('santa-letter-video-${addon.handle}', 'mute-btn-${addon.handle}');"
            style="position: absolute; top: 12px; right: 12px; z-index: 10; background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s;"
            onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
            onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
            <svg style="width: 16px; height: 16px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clip-rule="evenodd"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/>
            </svg>
          </button>
          ` : ''}

          ${mediaContent}

          <div style="position: absolute; bottom: 10px; left: 10px; right: 10px; display: flex; justify-content: ${hasVideo ? 'space-between' : 'flex-end'}; gap: 8px; z-index: 10;">
            ${hasVideo ? `
            <button onclick="event.stopPropagation(); handleVideoFullscreen('santa-letter-video-${addon.handle}');"
              style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
              onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
              <svg style="width: 14px; height: 14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
              </svg>
              Full Screen
            </button>
            ` : ''}

            <button onclick="event.stopPropagation(); window.BundleHelpModals?.show('modal-magical-letter-help');"
              style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
              onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
              <svg style="width: 14px; height: 14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Learn More
            </button>
          </div>
        </div>

        <div style="padding: 16px;">
          <div class="bundle-option__name" style="font-size: 1rem; font-weight: 700; margin-bottom: 6px;">
            ${cardName}
            ${addon.badge ? `<span style="background: rgb(var(--color-primary)); color: white; padding: 2px 8px; border-radius: 4px; font-size: 0.7rem; margin-left: 8px;">${addon.badge}</span>` : ''}
          </div>

          <div class="bundle-option__description" style="margin-bottom: 8px; color: rgb(var(--color-drawer-text) / 0.8); font-size: 0.85rem;">
            ${cardDescription}
          </div>

          <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: ${hasConfig ? '12px' : '0'};">
            <div class="bundle-option__price" style="font-size: 1.1rem; font-weight: 800; color: rgb(var(--color-primary)); margin: 0;">
              ${window.bundleAdapter.formatPrice(addon.price)}
              ${addon.compareAtPrice && addon.compareAtPrice > addon.price ? `<span style="text-decoration: line-through; color: rgb(var(--color-drawer-text) / 0.5); font-size: 0.9rem; margin-left: 8px;">${window.bundleAdapter.formatPrice(addon.compareAtPrice)}</span>` : ''}
            </div>
            ${!hasConfig ? `
              <button onclick="event.stopPropagation(); toggleAddon('${stepId}', '${addon.handle}');"
                style="background: rgb(var(--color-primary)); color: white; border: none; padding: 10px 20px; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; transition: opacity 0.2s; white-space: nowrap;"
                onmouseover="this.style.opacity='0.9'"
                onmouseout="this.style.opacity='1'">
                Customise
              </button>
            ` : ''}
          </div>

          ${hasConfig ? `
            <div class="bundle-option__config-display" style="background: rgb(var(--color-primary) / 0.1); padding: 10px 12px; border-radius: 8px; font-size: 0.85rem; display: flex; align-items: center; gap: 8px;">
              <svg style="width: 16px; height: 16px; color: rgb(var(--color-primary)); flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <span><strong>Configured:</strong> ${isSelected.configuration.formData?.childName || 'Custom letter'}</span>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  /**
   * Render Number Plate special card
   */
  function renderNumberPlateCard(addon, stepId, isSelected, requiresConfig, hasConfig) {
    const hasVideo = addon.config?.videoUrl;
    const mediaContent = hasVideo
      ? `<video
           id="number-plate-video-${addon.handle}"
           autoplay
           muted
           loop
           playsinline
           webkit-playsinline
           x5-playsinline
           style="width: 100%; display: block; aspect-ratio: 16/9; object-fit: cover;">
           <source src="${addon.config.videoUrl}" type="video/mp4">
         </video>`
      : (addon.featured_image
          ? `<img src="${addon.featured_image}" alt="${addon.name}" style="width: 100%; display: block; aspect-ratio: 4/1; object-fit: cover;">`
          : `<div style="width: 100%; aspect-ratio: 5/1; display: flex; align-items: center; justify-content: center; background: rgb(var(--color-primary) / 0.1); font-size: 2rem;">${getIconEmoji(addon.icon)}</div>`
        );

    return `
      <div class="bundle-option number-plate-special ${isSelected ? 'selected' : ''}"
           data-addon-handle="${addon.handle}"
           data-step="${stepId}"
           onclick="toggleAddon('${stepId}', '${addon.handle}')"
           style="padding: 0; position: relative; display: block !important; overflow: hidden;">

        ${requiresConfig && !hasConfig ? `<div class="config-badge config-badge--customize">Click to Customise</div>` : ''}
        ${hasConfig ? `<div class="config-badge config-badge--configured">✓ Click to Edit</div>` : ''}

        <div style="position: relative; margin: 0; overflow: hidden; background: ${hasVideo ? '#000' : 'rgb(var(--color-primary) / 0.05)'};">

          <div class="bundle-option__checkbox" style="position: absolute; top: 12px; left: 12px; z-index: 10;">
            ${isSelected ? '<span class="bundle-option__checkbox-icon">✓</span>' : ''}
          </div>

          ${hasVideo ? `
          <button
            id="mute-btn-${addon.handle}"
            onclick="event.stopPropagation(); handleMuteToggle('number-plate-video-${addon.handle}', 'mute-btn-${addon.handle}');"
            style="position: absolute; top: 12px; right: 12px; z-index: 10; background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s;"
            onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
            onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
            <svg style="width: 16px; height: 16px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clip-rule="evenodd"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/>
            </svg>
          </button>
          ` : ''}

          ${mediaContent}

          <div style="position: absolute; bottom: 10px; left: 10px; right: 10px; display: flex; justify-content: ${hasVideo ? 'space-between' : 'flex-end'}; gap: 8px; z-index: 10;">
            ${hasVideo ? `
            <button onclick="event.stopPropagation(); handleVideoFullscreen('number-plate-video-${addon.handle}');"
              style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
              onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
              <svg style="width: 14px; height: 14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
              </svg>
              Full Screen
            </button>
            ` : ''}

            <button onclick="event.stopPropagation(); window.BundleHelpModals?.show('modal-number-plate-help');"
              style="background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(8px); color: white; border: 1px solid rgba(255, 255, 255, 0.3); padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;"
              onmouseover="this.style.background='rgba(0, 0, 0, 0.85)'"
              onmouseout="this.style.background='rgba(0, 0, 0, 0.7)'">
              <svg style="width: 14px; height: 14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Learn More
            </button>
          </div>
        </div>

        <div style="padding: 10px;">
          <div class="bundle-option__name" style="font-size: 1rem; font-weight: 700; margin-bottom: 6px;">
            ${addon.name}
            ${addon.badge ? `<span style="background: rgb(var(--color-primary)); color: white; padding: 2px 8px; border-radius: 4px; font-size: 0.7rem; margin-left: 8px;">${addon.badge}</span>` : ''}
          </div>

          <div class="bundle-option__description" style="margin-bottom: 8px; color: rgb(var(--color-drawer-text) / 0.8); font-size: 0.85rem;">
            ${addon.description}
          </div>

          <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: ${hasConfig ? '12px' : '0'};">
            <div class="bundle-option__price" style="font-size: 1.1rem; font-weight: 800; color: rgb(var(--color-primary)); margin: 0;">
              ${window.bundleAdapter.formatPrice(addon.price)}
              ${addon.compareAtPrice && addon.compareAtPrice > addon.price ? `<span style="text-decoration: line-through; color: rgb(var(--color-drawer-text) / 0.5); font-size: 0.9rem; margin-left: 8px;">${window.bundleAdapter.formatPrice(addon.compareAtPrice)}</span>` : ''}
            </div>
            ${!hasConfig ? `
              <button onclick="event.stopPropagation(); toggleAddon('${stepId}', '${addon.handle}');"
                style="background: rgb(var(--color-primary)); color: white; border: none; padding: 10px 20px; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; transition: opacity 0.2s; white-space: nowrap;"
                onmouseover="this.style.opacity='0.9'"
                onmouseout="this.style.opacity='1'">
                Customise
              </button>
            ` : ''}
          </div>

          ${hasConfig ? `
            <div class="bundle-option__config-display" style="background: rgb(var(--color-primary) / 0.1); padding: 10px 12px; border-radius: 8px; font-size: 0.85rem; display: flex; align-items: center; gap: 8px;">
              <svg style="width: 16px; height: 16px; color: rgb(var(--color-primary)); flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <span><strong>Configured:</strong> Front: ${isSelected.configuration.front} | Back: ${isSelected.configuration.back} | ${isSelected.configuration.design}</span>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  /**
   * Render regular addon card
   */
  function renderRegularCard(addon, stepId, isSelected, requiresConfig, hasConfig) {
    const selectedVariantId = isSelected?.variantId || addon.variantId;
    const currentImage = isSelected?.featured_image || addon.featured_image;

    return `
      <div class="bundle-option ${isSelected ? 'selected' : ''}"
           data-addon-handle="${addon.handle}"
           data-step="${stepId}"
           onclick="toggleAddon('${stepId}', '${addon.handle}')">

        ${requiresConfig && !hasConfig ? `<div class="config-badge config-badge--customize">Click to Customise</div>` : ''}
        ${hasConfig ? `<div class="config-badge config-badge--configured">✓ Click to Edit</div>` : ''}

        <div class="bundle-option__content">
          <div class="bundle-option__checkbox">
            ${isSelected ? '<span class="bundle-option__checkbox-icon">✓</span>' : ''}
          </div>

          <div class="bundle-option__icon" id="addon-icon-${addon.handle.replace(/[^a-z0-9]/gi, '-')}">
            ${stepId === 'gifting' && currentImage
              ? `<img src="${currentImage}" alt="${addon.name}" loading="lazy">`
              : getIconEmoji(addon.icon)
            }
          </div>

          <div class="bundle-option__details">
            <div class="bundle-option__name">
              ${addon.name}
              ${addon.helpModal ? `
                <button
                  class="bundle-option__help-btn"
                  onclick="event.stopPropagation(); window.BundleHelpModals.show('${addon.helpModal}');"
                  aria-label="Learn more about ${addon.name}"
                  style="
                    background: none;
                    border: none;
                    padding: 4px 8px;
                    margin-left: 6px;
                    cursor: pointer;
                    color: rgb(var(--color-primary));
                    font-size: 16px;
                    display: inline-flex;
                    align-items: center;
                    vertical-align: middle;
                    transition: transform 0.2s ease;
                  "
                  onmouseover="this.style.transform='scale(1.1)'"
                  onmouseout="this.style.transform='scale(1)'">
                  ℹ️
                </button>
              ` : ''}
            </div>

            <div class="bundle-option__description">${addon.description || ''}</div>

            ${addon.helpModal ? `
              <button
                class="bundle-option__preview-btn"
                onclick="event.stopPropagation(); window.BundleHelpModals.show('${addon.helpModal}');"
                style="
                  background: transparent;
                  border: 2px solid rgb(var(--color-primary));
                  color: rgb(var(--color-primary));
                  padding: 8px 16px;
                  border-radius: 6px;
                  font-size: 14px;
                  font-weight: 600;
                  cursor: pointer;
                  margin-top: 8px;
                  display: inline-flex;
                  align-items: center;
                  gap: 6px;
                  transition: all 0.2s ease;
                "
                onmouseover="this.style.background='rgb(var(--color-primary))'; this.style.color='white';"
                onmouseout="this.style.background='transparent'; this.style.color='rgb(var(--color-primary))';">
                <svg style="width: 14px; height: 14px;" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"/>
                </svg>
                Watch Preview Video
              </button>
            ` : ''}

            ${addon.hasVariants ? `
              <div class="bundle-option__variants" onclick="event.stopPropagation();">
                <select
                  class="bundle-variant-select"
                  onchange="updateAddonVariant('${stepId}', '${addon.handle}', this.value)"
                  style="width: 100%; padding: 0.5rem; margin-top: 0.5rem; border: 2px solid rgb(var(--color-drawer-text) / 0.2); border-radius: 6px; background: rgb(var(--color-drawer-background)); color: rgb(var(--color-drawer-text)); font-size: 0.875rem;">
                  ${(() => {
                    const availableVariants = addon.variants.filter(v => v.available);
                    console.log('[BundleAddonCard] ' + addon.handle + ': Total variants=' + addon.variants.length + ', Available=' + availableVariants.length);
                    return availableVariants.map(variant => `
                    <option value="${variant.id}" ${variant.id == selectedVariantId ? 'selected' : ''}>
                      ${variant.title}${variant.price !== addon.price ? ` (+${window.bundleAdapter.formatPrice(variant.price - addon.price)})` : ''}
                    </option>
                  `).join('');
                  })()}
                </select>
              </div>
            ` : ''}

            ${hasConfig && addon.handle === 'number-plate-addon' ? `
              <div class="bundle-option__config-display">
                Front: ${isSelected.configuration.front} | Back: ${isSelected.configuration.back} | ${isSelected.configuration.design}
              </div>
            ` : ''}

            ${hasConfig && addon.handle === 'personalised-letter' ? `
              <div class="bundle-option__config-display">
                For: ${isSelected.configuration.formData.childName} | From: ${window.letterTemplates?.[isSelected.configuration.selectedTheme]?.displayName || isSelected.configuration.selectedTheme}
              </div>
            ` : ''}

            ${hasConfig && addon.handle === 'personalised-animated-video' ? `
              <div class="bundle-option__config-display">
                For: ${isSelected.configuration.childName} | Email: ${isSelected.configuration.email}
              </div>
            ` : ''}

            <div class="bundle-option__price">${window.bundleAdapter.formatPrice(addon.price)}</div>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Main render function that determines which card type to render
   */
  function render(addon, stepId, isSelected, customBundleSelections) {
    const requiresConfig = ['number-plate-addon', 'personalised-letter', 'personalised-animated-video'].includes(addon.handle);
    const hasConfig = isSelected && isSelected.configuration;

    // Check if there's a custom renderer from BundleSpecialCards
    if (typeof window.BundleSpecialCards !== 'undefined' && window.BundleSpecialCards[stepId]) {
      const renderer = window.BundleSpecialCards[stepId][addon.handle];
      if (renderer && typeof renderer === 'function') {
        try {
          return renderer(addon, stepId, isSelected, requiresConfig, hasConfig);
        } catch (error) {
          console.error('[BundleAddonCard] Error rendering special card:', error);
        }
      }
    }

    // Check for Santa letter
    const isSantaLetter = addon.config?.productHandle === 'personalised-letter' ||
                          addon.handle === 'personalised-letter' ||
                          (addon.name && addon.name.toLowerCase().includes('letter') && addon.name.toLowerCase().includes('santa'));

    if (isSantaLetter) {
      return renderSantaLetterCard(addon, stepId, isSelected, requiresConfig, hasConfig);
    }

    // Check for Santa video
    const isSantaVideo = addon.config?.productHandle === 'personalised-animated-video' ||
                         addon.handle === 'personalised-animated-video' ||
                         (addon.name && addon.name.toLowerCase().includes('santa') && addon.name.toLowerCase().includes('video'));

    if (isSantaVideo) {
      return renderSantaVideoCard(addon, stepId, isSelected, requiresConfig, hasConfig);
    }

    // Check for number plate
    const isNumberPlate = addon.config?.productHandle === 'number-plate-addon' ||
                          addon.handle === 'number-plate-addon';

    if (isNumberPlate) {
      return renderNumberPlateCard(addon, stepId, isSelected, requiresConfig, hasConfig);
    }

    // Default to regular card
    return renderRegularCard(addon, stepId, isSelected, requiresConfig, hasConfig);
  }

  // Public API
  return {
    render: render,
    getIconEmoji: getIconEmoji
  };
})();

// Helper functions for video controls
window.handleVideoFullscreen = function(videoId) {
  const video = document.getElementById(videoId);
  if (!video) return;

  if (video.webkitEnterFullscreen && typeof video.webkitEnterFullscreen === 'function') {
    try { video.webkitEnterFullscreen(); }
    catch(e) { launchIntoFullscreen(video); }
  }
  else if (video.requestFullscreen) {
    video.requestFullscreen().then(() => { video.controls = true; });
  }
  else if (video.webkitRequestFullscreen) { video.webkitRequestFullscreen(); video.controls = true; }
  else if (video.msRequestFullscreen) { video.msRequestFullscreen(); video.controls = true; }
  else if (video.mozRequestFullScreen) { video.mozRequestFullScreen(); video.controls = true; }

  function launchIntoFullscreen(element) {
    if(element.requestFullscreen) { element.requestFullscreen(); element.controls = true; }
    else if(element.mozRequestFullScreen) { element.mozRequestFullScreen(); element.controls = true; }
    else if(element.webkitRequestFullscreen) { element.webkitRequestFullscreen(); element.controls = true; }
    else if(element.msRequestFullscreen) { element.msRequestFullscreen(); element.controls = true; }
  }

  const fullscreenChangeHandler = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement &&
        !document.mozFullScreenElement && !document.msFullscreenElement) {
      video.controls = false;
      document.removeEventListener('fullscreenchange', fullscreenChangeHandler);
      document.removeEventListener('webkitfullscreenchange', fullscreenChangeHandler);
      document.removeEventListener('mozfullscreenchange', fullscreenChangeHandler);
      document.removeEventListener('MSFullscreenChange', fullscreenChangeHandler);
    }
  };

  document.addEventListener('fullscreenchange', fullscreenChangeHandler);
  document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler);
  document.addEventListener('mozfullscreenchange', fullscreenChangeHandler);
  document.addEventListener('MSFullscreenChange', fullscreenChangeHandler);
};

window.handleMuteToggle = function(videoId, btnId) {
  const video = document.getElementById(videoId);
  const btn = document.getElementById(btnId);
  if (!video || !btn) return;

  video.muted = !video.muted;
  btn.innerHTML = video.muted
    ? '<svg style="width: 16px; height: 16px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clip-rule="evenodd"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/></svg>'
    : '<svg style="width: 16px; height: 16px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"/></svg>';
};